import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { CustomDateComponent } from '../reports/customdate/custom-date.component';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { GlobalService } from '../services/global.service';
import { PumpService } from '../services/pump.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';


@Component({
  selector: 'app-pumpindividual',
  templateUrl: './pumpindividual.component.html',
  styleUrls: ['./pumpindividual.component.scss']
})
export class PumpindividualComponent implements OnInit {

 
  dataList = [{ "transformerDetails": "BH-1131", "pump": ["pump1", "pump2"], "params": ["current", "DEtemp", "NDEtemp", "phaseTemp", "sumpLevel", "waterLevel", "dischargePressureLow", "overLoad", "voltage", "waterFlow"] }, { "transformerDetails": "DG-001", "pump": ["pump1", "pump2"], "params": ["current", "DEtemp", "NDEtemp", "phaseTemp", "sumpLevel", "waterLevel", "dischargePressureLow", "overLoad", "voltage", "waterFlow"] }]
  selectedTransformer: any;
  selectedPump: any;
  paramList = this.dataList[0].params;
  durationList = [
    { id: 1, name: 'Today' },
    { id: 2, name: 'Yesterday' },
    { id: 3, name: 'This Week' },
    { id: 4, name: 'This Month' },
    { id: 5, name: 'Last Month' },
    { id: 6, name: 'Custom' }
  ];
  selectedDuration = this.durationList[0]
  pumpList = this.dataList[0].pump;
  currentUserData = JSON.parse(localStorage.getItem('userData'));
  mainDate;
  selectedParameter;
  data: any = [];
  graphValue: any = [];
  buchhlozSrc = "";
  abSrc = "";
  showcurrent:any;
  isLighting: boolean = false;
  isPumpOn: boolean = false;

  isDischarge = false;



  graph: any = {
    layout: {
      title: "",
      autosize: true,
      responsive: true, // Make the graph responsive
      xaxis: {
        title: {
          text: 'Time',
          font: {
            family: 'Arial',
            size: 18,
            color: '#000000',
          }
        },
      },
      yaxis: {
        title: {
          text: 'Value',
          font: {
            family: 'Arial',
            size: 18,
            color: '#000000'
          }
        }
      },
      shapes: []
    },
    config: { displaylogo: false, modeBarButtonsToRemove: ['zoom2d', 'pan2d', 'select2d', 'lasso2d', 'toggleSpikelines', 'hoverClosestCartesian', 'hoverCompareCartesian'] }
  };
  //****new******/
  selectedCountry;
  lightningTransformerFeedback:any=0;
  buchholz =1;
  pumponestatus = 0;
  abswitch = 0;
  jsonReadings;
  dateAray;
  transformerList;
  selectedTransformerForHealth
  pumpIdsArray;
  selectedpump;
  hasData: boolean; // Flag to check if data exists
  timeselection = {
    type: "Today",
    startDate: "",
    endDate: ""
  };
  totalPumpOnTime: number;
  totalPumpOnTimeInHours: number=0;
  totalPumpOnTimeInMinutes: number=0;
  totalPumpOnTimeInSeconds: number=0;
  totalPumpOnTimeInDays: number =0;
  nodata: any;
  constructor(private ngxLoader: NgxUiLoaderService,private pumpservice: PumpService, private matDialog: MatDialog, private globalService: GlobalService) { }

  ngOnInit() {
    this.ngxLoader.startLoader('indgraph');
    this.getListofTransformerInitial();
    this.getpumpIds();

  }
  //*******************************NEW CODE**************************************/

  getListofTransformerInitial() {
    let payloadtogetTransformer = {
      "countryid": this.selectedCountry ? this.selectedCountry.id : null,
      "stateid": null,
      "cityid": null,
      "zoneid": null,
      "locationid": null,
      "transformerid": null,
    };
    this.globalService.getfilteredTransformers(JSON.stringify(payloadtogetTransformer), localStorage.getItem('userData')).subscribe((response: any) => {
      
      if (response && response.code === '1' && response.result.length > 0) {
        this.transformerList = response.result;
        this.transformerList.map(e => {
          e.label = `${e.transformerid}[ ${e.sitename} ]`;
        });
        this.selectedTransformerForHealth = response.result[0];
      }
    })
  }
  calculatePumpOnTime(data): number {
    let pumpOnTime = 0;
    let startTime: Date | null = null;

    data.forEach(record => {
      // Remove extra quotation marks from the date string
      const cleanedDate = record.Date.replace(/'/g, '');

      if (record.pumponffeedback === 1) {
        if (startTime === null) {
          startTime = new Date(cleanedDate);
        
        }
      } else {
        if (startTime !== null) {
          const endTime = new Date(cleanedDate);
         pumpOnTime += (endTime.getTime() - startTime.getTime()) / 1000;
          startTime = null;
        }
      }
    });

    // If pump was still on at the end of the data period
    if (startTime !== null) {
      const endTime = new Date(data[data.length - 1].Date.replace(/'/g, ''));
     pumpOnTime += (endTime.getTime() - startTime.getTime()) / 1000;
    }

   
    this.convertSecondsToTimeUnits(pumpOnTime);
    return pumpOnTime;
  }

  convertSecondsToTimeUnits(totalSeconds: number) {
    this.totalPumpOnTimeInDays = Math.floor(totalSeconds / 86400);
    totalSeconds %= 86400;
    this.totalPumpOnTimeInHours = Math.floor(totalSeconds / 3600);
    totalSeconds %= 3600;
    this.totalPumpOnTimeInMinutes = Math.floor(totalSeconds / 60);
    this.totalPumpOnTimeInSeconds = totalSeconds % 60;
    console.log("Total On Time:", 
      `${this.totalPumpOnTimeInDays} days, ` + 
      `${this.totalPumpOnTimeInHours} hours, ` + 
      `${this.totalPumpOnTimeInMinutes} minutes, and ` + 
      `${this.totalPumpOnTimeInSeconds} seconds`
    );
  }
  OnFilterChange(value, type) {
    if (type === "pump") {
      const data = { "pumpid": value, "duration": this.timeselection };
      this.pumpservice.gatewayReport(data).subscribe(async (response: any) => {
        if (!response || !response.result || !Array.isArray(response.result)) {
          console.error("Invalid response format:", response);
          return;
        }
  
        const parsedData = response.result.map(element => {
          try {
            return JSON.parse(element.pumpreadings);
          } catch (error) {
            console.error("Error parsing pump readings:", element.pumpreadings, error);
            return null;
          }
        }).filter(element => element !== null);
  
        if (parsedData.length === 0) {
          this.hasData = false;
          console.warn("No valid pump readings found in the response.");
          return;
        }
  
        console.log("response", response.result);
  
        this.totalPumpOnTime = this.calculatePumpOnTime(parsedData);
  
        const lastReading = parsedData[parsedData.length - 1];
        if (lastReading) {
          this.buchholz = lastReading.Transformer_buchholz_Act;
          this.abswitch = lastReading.AB_Switch_On_Feedback;
          this.lightningTransformerFeedback = lastReading.Lighting_Transformer_On_Feedback ;
          this.showcurrent = lastReading.pumponffeedback === 1;
          const dateStr = lastReading["Date"].replace(/'/g, '');
          const dateObj = new Date(dateStr);
          const currentTime = new Date();
          const timeDifference = currentTime.getTime() - dateObj.getTime();
          this.pumponestatus = timeDifference <= 30 * 60 * 1000
            ? lastReading.pumponffeedback
            : 0;
        } else {
          console.warn("No last reading data available.");
          return;
        }
  
        if (response.result.length > 0) {
          this.jsonReadings = parsedData;
          this.jsonReadings.forEach(element =>{
            if(element.pumponffeedback == 0){
              element.L1 = 0;
              element.L2 = 0;
              element.L3 = 0;
            }
          })
          this.dateAray = parsedData.map(element => element.Date);
          this.hasData = this.dateAray.length > 0;
          this.updateSelected("motorrphasetemperature");
        } else {
          this.hasData = false;
        }
      }, error => {
        console.error("Error fetching gateway report:", error);
      });
    }
  }
  
  getpumpIds() {
    let data = { "roleid": this.currentUserData.roleid, "userid": this.currentUserData.userid };
    this.pumpservice.getPumpIds(data).subscribe(async (response1: any) => {
     
      if (response1.result.length > 0) {
        this.pumpIdsArray = response1.result.map(pump => pump.pump_id);
      }

      this.selectedpump = this.pumpIdsArray[0];
      this.OnFilterChange(this.selectedpump, "pump")
      console.log("called from line no 254")
    });

  }

  //*******************************OLD CODE**************************************/

  onDurationChange() {
    this.ngxLoader.startLoader('indgraph');
    const selectedDuration = this.selectedDuration;
    console.log('Selected Duration:', selectedDuration);
    
    this.timeselection.type = selectedDuration.name;
    const duration = this.calculateDuration(selectedDuration);
    this.timeselection.startDate = duration.startdate;
    this.timeselection.endDate = duration.enddate;

    this.OnFilterChange(this.selectedpump, 'pump'); // Assuming you have a method like this
  }

  calculateDuration(selectedDuration) {
    let startdate, enddate, filters;

    switch (selectedDuration.id) {
      case 1: // Today
        startdate = moment().format('YYYY-MM-DD');
        enddate = moment().format('YYYY-MM-DD');
        filters = 'Today';
        break;
      case 2: // Yesterday
        startdate = moment().subtract(1, 'day').format('YYYY-MM-DD');
        enddate = moment().subtract(1, 'day').format('YYYY-MM-DD');
        filters = 'Yesterday';
        break;
      case 3: // This Week
        startdate = moment().startOf('week').format('YYYY-MM-DD');
        enddate = moment().endOf('week').format('YYYY-MM-DD');
        filters = 'This Week';
        break;
      case 4: // This Month
        startdate = moment().startOf('month').format('YYYY-MM-DD');
        enddate = moment().endOf('month').format('YYYY-MM-DD');
        filters = 'This Month';
        break;
      case 5: // Last Month
        startdate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
        enddate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
        filters = 'Last Month';
        break;
      case 6: // Custom
        const dialogConfig = new MatDialogConfig();
        let dialogRef = this.matDialog.open(CustomDateComponent, {
          autoFocus: false,
          height: '350px',
          width: '450px'
        });
        dialogRef.afterClosed().subscribe(value => {
          if (value) {
            startdate = value.startDate;
            enddate = value.endDate;
            filters = 'Custom';

            this.timeselection.type = filters;
            this.timeselection.startDate = startdate;
            this.timeselection.endDate = enddate;

            this.OnFilterChange(this.selectedpump, 'pump'); // Assuming you have a method like this
          }
        });
        break;
      default:
        // Handle default case
        break;
    }

    return { startdate, enddate, filters };
  }
  updateSelected(selectedParameter) {
    this.selectedParameter = selectedParameter;
    this.createGraph();
  }
  formatTitle(str) {
    // Define a map of input strings to their formatted versions
    const titleMap = {
      "motorrphasetemperature": "Motor  Phase Temperature",
      "pumpcurrent": "Current",
      "motorndetemperature": "Motor Nde Temperature",
      "motordetemperature": "Motor De Temperature",
      "pumpdplow": "Pump Discharge Pressure Low",
      "overload": "Overload",
      "Water_Flow": "Water Flow",
      "Sump_Level": "Sump Level",
      "pumponffeedback": "Pump On Off Feedback"
    };

    if (titleMap.hasOwnProperty(str)) {
      return titleMap[str];
    }

  }
  createGraph() {
   
    let param = this.selectedParameter;
    console.log("param original", param);
  
    this.graph.layout = {
      title: this.formatTitle(param),
      xaxis: {
        title: {
          text: 'Time',
          font: {
            family: 'Arial',
            size: 18,
            color: '#000000',
          }
        },
      },
      yaxis: {
        title: {
          text: 'Value',
          font: {
            family: 'Arial',
            size: 18,
            color: '#000000'
          }
        }
      },
    };
  
    let pumpCurrentArray = this.jsonReadings.map(pump => pump[param]);
  
    if (param == "pumpcurrent") {
     
        pumpCurrentArray = this.jsonReadings.map(pump => ((pump['L1'] + pump['L2'] + pump['L3']) / 3).toFixed(2));
    
    }
  
    if (param != 'motorrphasetemperature') {
      if (pumpCurrentArray.length === 0 || this.dateAray.length === 0) {
        this.ngxLoader.stopLoader('indgraph');
        return;
      }
      this.data = [{
        x: this.dateAray,
        y: pumpCurrentArray,
        type: 'scatter',
        text: param,
        mode: 'lines+markers',
        marker: { color: 'blue' }
      }];
    } else {
      const pumpRPhaseArray = this.jsonReadings.map(pump => pump[param]);
      const pumpYPhaseArray = this.jsonReadings.map(pump => pump['motoryphasetemperature']);
      const pumpBPhaseArray = this.jsonReadings.map(pump => pump['motorbphasetemperature']);
      if (pumpRPhaseArray.length === 0 && pumpYPhaseArray.length === 0 && pumpBPhaseArray.length === 0 || this.dateAray.length === 0) {
        this.ngxLoader.stopLoader('indgraph');
        return;
      }
      this.data = [
        {
          x: this.dateAray,
          y: pumpRPhaseArray,
          name: "R Phase",
          type: 'scatter',
          mode: 'lines+markers',
          marker: { color: 'red' }
        },
        {
          x: this.dateAray,
          y: pumpYPhaseArray,
          name: "Y Phase",
          type: 'scatter',
          mode: 'lines+markers',
          marker: { color: 'yellow' }
        },
        {
          x: this.dateAray,
          y: pumpBPhaseArray,
          name: "B Phase",
          type: 'scatter',
          mode: 'lines+markers',
          marker: { color: 'blue' }
        }
      ];
    }
    
    this.ngxLoader.stopLoader('indgraph'); // Stop the loader after setting the data
  }
}
